// extracted by mini-css-extract-plugin
export default {"image":"styles_image__xGAvB","hide":"styles_hide__uvWJy","circle":"styles_circle__cfuW4","loader":"styles_loader__qScWo","placeholder":"styles_placeholder__-PH3I"};